__webpack_require__.p = "https://uat.acct.byonde.asia/";